import React, { createContext, useState, ReactNode, useCallback } from 'react';
import enTranslations from './translations/en.json';
import zhTranslations from './translations/zh.json';

export type LanguageType = 'en' | 'zh';

interface I18nContextType {
  language: LanguageType;
  setLanguage: (lang: LanguageType) => void;
  t: (key: string) => string;
}

export const I18nContext = createContext<I18nContextType | undefined>(undefined);

interface I18nProviderProps {
  children: ReactNode;
}

const translations: Record<LanguageType, any> = {
  en: enTranslations,
  zh: zhTranslations,
};

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<LanguageType>(() => {
    // 从 localStorage 获取保存的语言偏好
    const saved = localStorage.getItem('language') as LanguageType;
    return saved || 'zh';
  });

  const t = useCallback((key: string): string => {
    const keys = key.split('.');
    let value: any = translations[language];

    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // 如果找不到翻译，返回 key 本身
      }
    }

    return typeof value === 'string' ? value : key;
  }, [language]);

  const handleSetLanguage = (lang: LanguageType) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <I18nContext.Provider value={{ language, setLanguage: handleSetLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
};
